import React from "react";
import logo from "./logo.svg";
import "./App.css";
import Navbar from "./components/Navbar";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import Header from "./components/Header";
import Main from "./components/main";
import Create from "./components/Create";
import FirebaseState from "./firebase/firebaseState";
import Login from "./components/Login";
import EventState from "./event/EventState";
import Lesson from "./components/Lesson";
import LessonList from "./components/LessonList";
import Home from "./components/Home";
import CreateExercise from "./components/CreateExercise";
import ExerciseList from "./components/ExercisesList";
import Footer from "./components/Footer";
import Dostop from "./components/Dostop";
import Cookies from "./components/Cookies";

function App() {
  return (
    <div>
      <BrowserRouter>
        <FirebaseState>
          <EventState>
            <Navbar />
            <Switch>
              <Route exact path='/' component={Home} />
              <Route exact path='/create' component={Create} />
              <Route exact path='/createExercise' component={CreateExercise} />
              <Route exact path='/vaje' component={ExerciseList} />
              <Route exact path='/login' component={Login} />
              <Route exact path='/naloge' component={LessonList} />
              <Route exact path='/dostop' component={Dostop} />
              <Route exact path='/naloge/:lesson_id' component={Lesson} />
              <Route exact path='/cookies' component={Cookies} />
            </Switch>
          </EventState>
        </FirebaseState>
      </BrowserRouter>
    </div>
  );
}

export default App;
